export const locale_fr = {
    future: "dans %s",
    past: "il y a %s",
    s: 'quelques secondes',
    m: "une minute",
    mm: "%d minutes",
    h: "une heure",
    hh: "%d heures",
    d: "un jour",
    dd: "%d jours",
    M: "un mois",
    MM: "%d mois",
    y: "un an",
    yy: "%d ans"
}
